import React, { Component } from 'react';
// import VideosList from './VideosList.js'; // Removed as App.js will handle this
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import './GoogleLogin.css';
import GoogleLogo from './assets/google_logo.svg';

class GoogleLoginComponent extends Component {
  constructor(props) {
    super(props);
    // eslint-disable-next-line
    const { cookies } = props;
    this.state = {};
  }
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  // Success Handler
  handleLogin = () => {
    window.location.href = `/api/OAuth/login`;
  };

  // Error Handler
  responseGoogleError = (response) => {
    console.log('Error response: ' + response);
  };

  // Logout Session and Update State
  handleLogOut = () => {
    this.props.cookies.remove('code');
    this.forceUpdate();
  };

  render() {
    const isLoggedIn = !!this.props.cookies.get('code');
    const { showLoginOnly } = this.props;

    if (isLoggedIn) {
      return (
        <div className="row mt-5">
          <div className="col-md-12">
            <div style={{ paddingTop: 30 }}>
              <div
                id="customBtn"
                className="customGPlusSignIn"
                onClick={this.handleLogOut}
                style={{ padding: 5, marginRight: 700 }}>
                <img src={GoogleLogo} alt="Google Logo" />
                <span className="buttonText">Logout</span>
              </div>
            </div>
            {/* <VideosList backend={this.props.backend}></VideosList> // Removed */}
          </div>
        </div>
      );
    }

    // Not logged in
    if (showLoginOnly) {
      return (
        <div style={{ paddingTop: 30 }} className="google-login-button-container"> {/* Added a class for potential styling */}
          <div
            id="customBtn"
            className="customGPlusSignIn"
            onClick={this.handleLogin}
            style={{ padding: 5 }}> {/* Removed marginRight for centering if needed via CSS */}
            <img src={GoogleLogo} alt="Google Logo" />
            <span className="buttonText">Sign in with Google</span>
          </div>
        </div>
      );
    }

    // Default case if not logged in and not showLoginOnly (though not used by App.js in the new flow)
    // This retains the original behavior if GoogleLoginComponent is used elsewhere without showLoginOnly
    return (
      <div className="row mt-5">
        <div className="col-md-12">
          <div style={{ paddingTop: 30 }}>
            <div
              id="customBtn"
              className="customGPlusSignIn"
              onClick={this.handleLogin}
              style={{ padding: 5, marginRight: 700 }}>
              <img src={GoogleLogo} alt="Google Logo" />
              <span className="buttonText">Login With Google</span>
            </div>
          </div>
          {/* <VideosList backend={this.props.backend}></VideosList> // Removed */}
        </div>
      </div>
    );
  }
}
export default withCookies(GoogleLoginComponent);
